// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import Meta from 'vue-meta';
import VueAnaytics from 'vue-analytics';
import messages from '@/constants/i18n';
import common from '@/utils/common';
import App from './App';
import router from './router';
import store from './store';

Vue.config.productionTip = false;

Vue.use(VueI18n);
Vue.use(Meta, {
  keyName: 'metaInfo', // the component option name that vue-meta looks for meta info on.
  attribute: 'data-vue-meta', // the attribute name vue-meta adds to the tags it observes
  ssrAttribute: 'data-vue-meta-server-rendered', // the attribute name that lets vue-meta know that meta info has already been server-rendered
  tagIDKeyName: 'vmid', // the property name that vue-meta uses to determine whether to overwrite or append a tag
});
Vue.use(VueAnaytics, {
  id: 'UA-73642952-5',
  router,
});

const i18n = new VueI18n({
  locale: common.methods.getLanguage(),
  fallbackLocale: 'en',
  messages,
});

/* eslint-disable no-new */
const app = new Vue({
  el: '#app',
  store,
  router,
  i18n,
  components: { App },
  template: '<App/>',
});

export default app;



// WEBPACK FOOTER //
// ./src/main.js